import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { INavigationInfo } from 'ds-feature-editor-navigation'
import { CurrentRouteInfoSymbol, NavigationInfoSymbol } from '@wix/thunderbolt-symbols'
import { ICurrentRouteInfo } from 'feature-router'
import { ILightbox, LightboxSymbol } from 'feature-lightbox'

const viewerManagerPagesApiFactory = (
	popups: ILightbox,
	navigationInfo: INavigationInfo,
	currentRouteInfo: ICurrentRouteInfo
): IViewerManagerImplementor<'pages'> => {
	const getPrimaryPageId = () => currentRouteInfo.getCurrentRouteInfo()?.pageId || ''

	return {
		pages: {
			getViewerLoadedPagesIds: () => navigationInfo.getLoadedPageIds(),
			getFocusedRootId: () => popups.getCurrentLightboxId() || getPrimaryPageId(),
			getPrimaryPageId,
			getCurrentUrlPageId: getPrimaryPageId,
			getCurrentPopupId: () => popups.getCurrentLightboxId() || '',
			isPopupOpened: () => popups.isOpen(),
			getAllRenderedRootIds: () => ['masterPage', getPrimaryPageId()],
		},
	}
}
export const ViewerManagerPagesApi = withDependencies(
	[LightboxSymbol, NavigationInfoSymbol, CurrentRouteInfoSymbol],
	viewerManagerPagesApiFactory
)
